import { getterTypes, situacoes } from '@/core/constants'

export default {
	computed: {
		temPermissaoEdicao() {
			return this.$store.getters[getterTypes.ATA.GET_TEM_PERMISSAO_EDICAO]
		},
		temPermissaoVisualizarAcompanhamento() {
			return this.$store.getters[getterTypes.ATA.GET_USUARIO_PODE_VISUALIZAR_ACOMPANHAMENTO]
		},
		usuarioPodeVerAdesoesDoAderente() {
			return this.$store.getters[getterTypes.ATA.GET_PODE_VER_ADESOES_DO_ADERENTE]
		},
		possuiAdesoesParaAnaliseDoGestor() {
			return this.$store.getters[getterTypes.ATA.GET_POSSUI_ADESOES_PARA_ANALISE_DO_GESTOR]
		},
		isAtaAdesao() {
			return this.$store.getters[getterTypes.ATA.GET_IS_ATA_ADESAO]
		},
		possuiDocumentoTipoAtaRegistroPreco() {
			return this.$store.getters[getterTypes.ATA.GET_POSSUI_DOCUMENTO_TIPO_ATA_REGISTRO_PRECO]
		},
		possuiDocumentoTipoAtaRegistroPrecoSemConcluirEdicao() {
			return this.$store.getters[getterTypes.ATA.GET_POSSUI_DOCUMENTO_TIPO_ATA_REGISTRO_PRECO_SEM_CONCLUIR_EDICAO]
		},
		possuiDocumentoTipoAtaRegistroPrecoNaoAssinado() {
			return this.$store.getters[getterTypes.ATA.GET_POSSUI_DOCUMENTO_TIPO_ATA_REGISTRO_PRECO_NAO_ASSINADO]
		},
		isMigracao() {
			return this.$store.getters[getterTypes.ATA.GET_IS_MIGRACAO]
		},
	},
	methods: {
		estaEmElaboracao(value) {
			if (value) {
				if (typeof value === 'string') {
					return value === situacoes.ATA.EM_ELABORACAO.value
				}
				return value.situacao === situacoes.ATA.EM_ELABORACAO.value
			}
			return false
		},
		estaEfetivado(value) {
			if (value) {
				if (typeof value === 'string') {
					return value === situacoes.ATA.EFETIVADO.value
				}
				return value.situacao === situacoes.ATA.EFETIVADO.value
			}
			return false
		},
		estaCancelada(value) {
			if (value) {
				if (typeof value === 'string') {
					return value === situacoes.ATA.CANCELADO.value
				}
				return value.situacao === situacoes.ATA.CANCELADO.value
			}
			return false
		},
		ehHistoricoProrrogacao(value) {
			if (value) {
				if (typeof value === 'string') {
					return value === situacoes.ATA.HISTORICO_PRORROGACAO.value
				}
				return value.situacao === situacoes.ATA.HISTORICO_PRORROGACAO.value
			}
			return false
		},
		estaBloqueada(value) {
			return !!value && value.isBloqueado
		},
		estaEnviadaPncp(value) {
			return !!value && value.isEnviadaPncp
		},
	},
}
